import React from 'react'
import EditableComponent from './EditableComponent'
import getEnumTranslation from '@/enums/enums'
import find from 'lodash/find'
import { DropDownList } from '@/components/dropDownList'
import { SnapshotDateMonthly, VALUES as SnapshotDateMonhtlyValues } from '@/enums/SnapshotDateMonthly'
import { DueDateMonthly, VALUES as DueDateMonthlyValues } from '@/enums/DueDateMonthly'

import OffsetInput from './OffsetInput'
import { Col, Row } from 'reactstrap'
// create array with values 1..31
const monthDays = Array(31).fill().map((_, index) => index + 1).map(x => ({ text: `${x}.`, value: `${x}` }))

class MonthlyDatePicker extends EditableComponent {
  handleDropDownListChange (value) {
    // if user selects 'day of month', check if current offset value can be represented
    // in month dropdown list. If not - reset offset to the first drop down list item value
    if (this.isDayOfMonthSelected(value)) {
      if (!find(monthDays, x => x.value === this.props.offset)) {
        this.props.onOffsetChange(monthDays[0].value)
      }
    }
    this.props.onIntValueChange(value)
  }
  renderDropDownList (data) {
    return (<DropDownList
      disabled={this.props.disabled}
      data={data}
      onChange={({ value }) => this.handleDropDownListChange(value)}
      value={this.props.intValue}
      textField='text'
      valueField='value' />)
  }
  isDayOfMonthSelected (intValue) {
    const { isDueDate } = this.props
    return intValue === (isDueDate ? DueDateMonthly.DAY_OF_MONTH : SnapshotDateMonthly.DAY_OF_MONTH)
  }
  renderInputControl () {
    // if user selects 'day of month' - render offset drop down list instead of numeric input
    if (this.isDayOfMonthSelected(this.props.intValue)) {
      return (<DropDownList
        disabled={this.props.disabled}
        data={monthDays}
        onChange={({ value }) => this.props.onOffsetChange(value)}
        value={this.props.offset}
        textField='text'
        valueField='value' />)
    }

    return <OffsetInput disabled={this.props.disabled} value={this.props.offset} onChange={offset => this.props.onOffsetChange(offset)} />
  }
  renderControl () {
    const { localize } = this.props
    const enumName = this.props.isDueDate ? 'DueDateMonthly' : 'SnapshotDateMonthly'
    const values = this.props.isDueDate ? DueDateMonthlyValues : SnapshotDateMonhtlyValues
    if (this.isEdited()) {
      const data = values.map(x => ({ text: getEnumTranslation({ localize, enumName, value: x }), value: x }))

      return (<Row className='f1'>
        <Col sm='6'>
          {this.renderDropDownList(data)}
        </Col>
        <Col sm='6'>
          {this.renderInputControl()}
        </Col>
      </Row>)
    }
    const text = getEnumTranslation({ localize, enumName, value: this.props.intValue })
    return this.renderReadOnlyText(text.replace('#', this.props.offset))
  }
}

export default MonthlyDatePicker



// WEBPACK FOOTER //
// ./src/components/Editors/MonthlyDatePicker.js